import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO36 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-6.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO36
